var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":_vm.loading}},[_c('v-card-title',[_vm._v("Tickets")]),_c('data-table',{attrs:{"headers":_vm.headersTickets,"promise":_vm.promiseTickets,"disablePagination":true},scopedSlots:_vm._u([{key:"item.DataCriacao",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("date")(item.DataCriacao))+" ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.status ? "Ativo" : "Inativo")+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }